import Marketplace from './MarketplaceContainer';

export default Marketplace;
